/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const routineChangeConfirmBodyChangeTimingThreeLocalDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const routineChangeConfirmBodyChangeStartLocalDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const routineChangeConfirmBodyChangeAnchorClockLocalRegExp = new RegExp(
  '^(?:[01]\\d|2[0-3]):[0-5]\\d$',
);
export const routineChangeConfirmBodyChangeRotationCountExclusiveMin = 0;
export const routineChangeConfirmBodyChangeRotationCountMax = 2147483647;

export const routineChangeConfirmBodyChangeParticipantsItemOrdinalMin = 0;
export const routineChangeConfirmBodyChangeParticipantsItemOrdinalMax = 19;

export const routineChangeConfirmBodyChangeParticipantsItemUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const routineChangeConfirmBodyChangeParticipantsMax = 20;

export const routineChangeConfirmBodyChangeRotationChangeTimingThreeLocalDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const routineChangeConfirmBodyChangeEndedAtOneOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const routineChangeConfirmBodyChangeSectionChangeOneSectionsItemStartWeekdayMax = 7;

export const routineChangeConfirmBodyChangeSectionChangeOneSectionsItemStartLocalMinuteMin = 0;
export const routineChangeConfirmBodyChangeSectionChangeOneSectionsItemStartLocalMinuteMax = 1439;

export const routineChangeConfirmBodyChangeSectionChangeOneSectionsItemEndWeekdayMax = 7;

export const routineChangeConfirmBodyChangeSectionChangeOneSectionsItemEndLocalMinuteMin = 0;
export const routineChangeConfirmBodyChangeSectionChangeOneSectionsItemEndLocalMinuteMax = 1439;

export const routineChangeConfirmBodyChangeSectionChangeOneSectionsItemFullWeekDefault = false;
export const routineChangeConfirmBodyChangeSectionChangeOneSectionsMax = 14;

export const routineChangeConfirmBodyChangeSectionChangeOneTimingThreeLocalDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const routineChangeConfirmBodyChangeSectionChangeOneEffectiveLocalDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const routineChangeConfirmBodyExpectedVersionExclusiveMin = 0;
export const routineChangeConfirmBodyExpectedVersionMax = 9007199254740991;

export const routineChangeConfirmBodyPreviewFingerprintMax = 256;

export const routineChangeConfirmBodyConfirmNewGapsDefault = false;
export const RoutineChangeConfirmBody = zod.object({
  change: zod.object({
    teamId: zod.unknown().optional(),
    scheduleId: zod.unknown().optional(),
    timeZone: zod.unknown().optional(),
    timing: zod
      .union([
        zod.object({
          mode: zod.literal('immediate'),
        }),
        zod.object({
          mode: zod.literal('cycle'),
        }),
        zod.object({
          mode: zod.literal('date'),
          localDate: zod.iso.date().regex(routineChangeConfirmBodyChangeTimingThreeLocalDateRegExp),
        }),
      ])
      .optional(),
    name: zod.string().optional(),
    startLocalDate: zod.iso
      .date()
      .regex(routineChangeConfirmBodyChangeStartLocalDateRegExp)
      .optional(),
    anchorClockLocal: zod
      .string()
      .regex(routineChangeConfirmBodyChangeAnchorClockLocalRegExp)
      .optional(),
    rotation: zod
      .object({
        unit: zod.enum(['day', 'week']),
        count: zod
          .int()
          .gt(routineChangeConfirmBodyChangeRotationCountExclusiveMin)
          .max(routineChangeConfirmBodyChangeRotationCountMax),
      })
      .optional(),
    participants: zod
      .array(
        zod.object({
          ordinal: zod
            .int()
            .min(routineChangeConfirmBodyChangeParticipantsItemOrdinalMin)
            .max(routineChangeConfirmBodyChangeParticipantsItemOrdinalMax),
          userId: zod.uuid().regex(routineChangeConfirmBodyChangeParticipantsItemUserIdRegExp),
        }),
      )
      .min(1)
      .max(routineChangeConfirmBodyChangeParticipantsMax)
      .optional(),
    effectiveLocalDate: zod.unknown().optional(),
    rotationChange: zod
      .object({
        action: zod.enum(['set', 'revise', 'cancel']),
        timing: zod
          .union([
            zod.object({
              mode: zod.literal('immediate'),
            }),
            zod.object({
              mode: zod.literal('cycle'),
            }),
            zod.object({
              mode: zod.literal('date'),
              localDate: zod.iso
                .date()
                .regex(routineChangeConfirmBodyChangeRotationChangeTimingThreeLocalDateRegExp),
            }),
          ])
          .optional(),
        effectiveLocalDate: zod.unknown().optional(),
      })
      .optional(),
    endedAt: zod
      .union([
        zod.union([
          zod.iso
            .datetime({ offset: true })
            .regex(routineChangeConfirmBodyChangeEndedAtOneOneRegExp),
          zod.literal('now'),
        ]),
        zod.null(),
      ])
      .optional(),
    sectionChange: zod
      .union([
        zod.object({
          action: zod.enum(['set', 'revise']),
          sections: zod
            .array(
              zod.object({
                startWeekday: zod
                  .int()
                  .min(1)
                  .max(routineChangeConfirmBodyChangeSectionChangeOneSectionsItemStartWeekdayMax),
                startLocalMinute: zod
                  .int()
                  .min(
                    routineChangeConfirmBodyChangeSectionChangeOneSectionsItemStartLocalMinuteMin,
                  )
                  .max(
                    routineChangeConfirmBodyChangeSectionChangeOneSectionsItemStartLocalMinuteMax,
                  ),
                endWeekday: zod
                  .int()
                  .min(1)
                  .max(routineChangeConfirmBodyChangeSectionChangeOneSectionsItemEndWeekdayMax),
                endLocalMinute: zod
                  .int()
                  .min(routineChangeConfirmBodyChangeSectionChangeOneSectionsItemEndLocalMinuteMin)
                  .max(routineChangeConfirmBodyChangeSectionChangeOneSectionsItemEndLocalMinuteMax),
                fullWeek: zod
                  .boolean()
                  .default(
                    routineChangeConfirmBodyChangeSectionChangeOneSectionsItemFullWeekDefault,
                  ),
              }),
            )
            .min(1)
            .max(routineChangeConfirmBodyChangeSectionChangeOneSectionsMax),
          timing: zod
            .union([
              zod.object({
                mode: zod.literal('immediate'),
              }),
              zod.object({
                mode: zod.literal('cycle'),
              }),
              zod.object({
                mode: zod.literal('date'),
                localDate: zod.iso
                  .date()
                  .regex(routineChangeConfirmBodyChangeSectionChangeOneTimingThreeLocalDateRegExp),
              }),
            ])
            .optional(),
          effectiveLocalDate: zod.iso
            .date()
            .regex(routineChangeConfirmBodyChangeSectionChangeOneEffectiveLocalDateRegExp)
            .optional(),
        }),
        zod.object({
          action: zod.literal('cancel'),
        }),
      ])
      .optional(),
  }),
  expectedVersion: zod
    .int()
    .gt(routineChangeConfirmBodyExpectedVersionExclusiveMin)
    .max(routineChangeConfirmBodyExpectedVersionMax),
  previewFingerprint: zod.string().min(1).max(routineChangeConfirmBodyPreviewFingerprintMax),
  confirmNewGaps: zod.boolean().default(routineChangeConfirmBodyConfirmNewGapsDefault),
});

export type RoutineChangeConfirmBody = zod.input<typeof RoutineChangeConfirmBody>;
export type RoutineChangeConfirmBodyOutput = zod.output<typeof RoutineChangeConfirmBody>;
